import { render, staticRenderFns } from "./userLimits.vue?vue&type=template&id=4482179c&scoped=true&"
import script from "./userLimits.vue?vue&type=script&lang=js&"
export * from "./userLimits.vue?vue&type=script&lang=js&"
import style0 from "./userLimits.vue?vue&type=style&index=0&id=4482179c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4482179c",
  null
  
)

export default component.exports